import React from 'react'
import { EscrevaContainer } from "../../../containers";
export default function EscrevaPage(props) {
    return (
        <div style={ { flexGrow: 1, display: 'flex' } } className='escreva-page-container'>
            <EscrevaContainer/>
        </div>
    )
}
